import * as React from "react";
import ArticleForm from "../shared/ArticleForm";
import useModelState from "../hooks/useModelState";
import useArticleFormModel from "../hooks/useArticleFormModel";
import PreviewButton from "./PreviewButton";
import useApi from "@/hooks/useApi";
import { useNavigate } from "react-router-dom";
import {
  PrimaryBlueButton,
  SecondaryBlueButton
} from "@velaro/velaro-component-lib";
import useToastAlert from "@/hooks/useToastAlert";
import { Severity } from "@velaro/velaro-component-lib";

export default function Create() {
  const [saving, setSaving] = React.useState(false);
  const [article, setArticle] = useArticleFormModel();
  const [modelState, setModelState] = useModelState();
  const api = useApi();
  const toastAlert = useToastAlert();
  const navigate = useNavigate();

  async function save(publish: boolean) {
    setSaving(true);
    try {
      const resp = await api.admin.post("api/kb/articles", {
        ...article,
        isPublished: publish
      });
      if (resp.status === 400) {
        toastAlert.displayToast(Severity.Error, "Failed to save article");
        setSaving(false);
        return;
      }
      toastAlert.displayToast(
        Severity.Success,
        publish ? "Article published" : "Draft saved"
      );
      navigate("/kb/articles");
    } catch (err) {
      console.error("Failed to save article:", err);
      toastAlert.displayToast(Severity.Error, "Failed to save article");
      setSaving(false);
    }
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex items-start justify-between mb-6">
        <div className="flex items-center gap-2 text-sm text-slate-500">
          <button type="button" onClick={() => navigate("/kb/articles")} className="hover:text-blue-600">
            Articles
          </button>
          <i className="fa fa-chevron-right text-xs" />
          <span className="text-slate-700 font-medium">New Article</span>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <PreviewButton title={article.title} content={article.content} />
          <SecondaryBlueButton
            label={saving ? "Saving…" : "Save Draft"}
            disabled={saving}
            onClick={() => save(false)}
          />
          <PrimaryBlueButton
            label={saving ? "Saving…" : "Publish"}
            disabled={saving}
            onClick={() => save(true)}
          />
        </div>
      </div>

      <ArticleForm
        article={article}
        onChange={(props) => {
          setArticle((oldState) => ({ ...oldState, ...props }));
        }}
        modelState={modelState}
      />
    </div>
  );
}
